function Help() {
    return(<div className={"contentPage"}>
        <h1>Help</h1>
    </div>)
}

export default Help;